"use client";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

export const useScrollToTop = () => {
  const pathname = usePathname();
  const getHash = () =>
    typeof window !== "undefined"
      ? decodeURIComponent(window.location.hash.replace("#", ""))
      : undefined;
  useEffect(() => {
    if (getHash() != "order-tracking") window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
